import googleLogo from '@asset/image/google-logo.png';
import naverLogo from '@asset/image/naver-logo.png';
import kakaoLogo from '@asset/image/kakao-logo.png';
import appleLogo from '@asset/image/apple-logo.png';
import otterLogoImage from '@asset/image/otter-brick-logo.webp';
import gridgioLogoImage from '@asset/image/gridgio-logo.svg';
import { EAuthType } from '@datatype/type';
import { EService } from '@datatype/type';
import { SERVICE } from '@config/environment';

export const createAuthLogoImage = () => {
  switch (SERVICE) {
    case EService.GRIDGIO:
      return gridgioLogoImage;
    case EService.MOASHELF:
    case EService.IYAGIGO:
    default:
      return otterLogoImage;
  }
};

export const getConnectionAccount = (authType: string) => {
  let logo: any;
  let name: string;

  switch (authType) {
    case EAuthType.GOOGLE:
      logo = googleLogo;
      name = '구글';
      break;
    case EAuthType.NAVER:
      logo = naverLogo;
      name = '네이버';
      break;
    case EAuthType.KAKAO:
      logo = kakaoLogo;
      name = '카카오';
      break;
    case EAuthType.APPLE:
      logo = appleLogo;
      name = '애플';
      break;
    default:
      logo = createAuthLogoImage();
      name = '';
      break;
  }

  return { name, logo };
};
